import React from 'react';
import PropTypes from 'prop-types';
import {Skeleton} from '@tenancy.nz/ui';

function SkeletonContent({
  children = null,
  loading = false,
  variant = 'text',
  ...rest
}) {
  if (loading) {
    return <Skeleton variant={variant} {...rest} />;
  }
  return children;
}

SkeletonContent.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  variant: PropTypes.oneOf(['circular', 'rectangular', 'text']),
};

SkeletonContent.defaultProps = {
  children: null,
  loading: false,
  variant: 'text',
};

export default SkeletonContent;
